import {NgModule} from '@angular/core';
import {PipeModule} from './pipe/pipe.module';
import {AddressModule} from './ui/address/address.module';
import {BillingAccountModule} from './ui/billing-account/billing-account.module';
import {IndClientModule} from './ui/ind-client/ind-client.module';
import {InterpreterBoxModule} from './ui/interpreter-box/interpreter-box.module';
import {InterpreterModule} from './ui/interpreter/interpreter.module';
import {MobileHeaderModule} from './ui/mobile-header/mobile-header.module';
import {OrgRepModule} from './ui/org-rep/org-rep.module';
import {TermandconditionModule} from './ui/termandcondition/termandcondition.module';

@NgModule({
  imports: [
    PipeModule,
    AddressModule,
    BillingAccountModule,
    IndClientModule,
    InterpreterModule,
    InterpreterBoxModule,
    MobileHeaderModule,
    OrgRepModule,
    TermandconditionModule,
  ],
  exports: [
    PipeModule,
    AddressModule,
    BillingAccountModule,
    IndClientModule,
    InterpreterModule,
    InterpreterBoxModule,
    MobileHeaderModule,
    OrgRepModule,
    TermandconditionModule,
  ],
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts